import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { connectState } from "../libs/connect"



import MintsPage from './MintsPage.vue';
import NamesPage from './NamesPage.vue';

const __default__ = {
  name: 'HomePage',
  props: {
    msg: String
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const activeIndex = connectState.activeIndex;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(activeIndex)==='1')
      ? (_openBlock(), _createBlock(MintsPage, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(activeIndex)==='2')
      ? (_openBlock(), _createBlock(NamesPage, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})